<app-sidesheet [open]="!!routeNetworkIdFromUrl()" (closed)="closeSidesheet()"
  ><router-outlet />
</app-sidesheet>

<app-map class="map-page" [sideSheetUrl]="routeNetworkIdFromUrl()" />
